import { RootState } from 'app/reducer';
import Table, { TableCol } from 'modules/Layout/component/Table';
import { PartialSearchingProps, SortParams } from 'modules/Shared/type';
import React, { createRef, ReactNode } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import ActionShow from 'modules/Layout/component/Action/Show';
import { getPathUrl } from 'modules/Shared/helper/api';
import TermsOfService from 'modules/Policy/model/TermsOfService';
import {
  setTOSListParamsAction,
  SetTOSListParamsAction
} from 'modules/Policy/action/list';
import { ROUTE_TOS_DETAILS, ROUTE_UPDATE_TOS } from 'modules/Policy/routes';
import ActionDelete from 'modules/Layout/component/Action/Delete';
import DeleteTermsOfServiceModal, {
  DeleteTermsOfServiceModal as DeleteTermsOfServiceModalType
} from 'modules/Policy/component/Modal/Delete';
import ActionUpdate from 'modules/Layout/component/Action/Update';

export interface StateProps {
  termsOfServices: TermsOfService[];
  sort: SortParams;
}

export interface DispatchProps {
  setParams: (payload: PartialSearchingProps) => SetTOSListParamsAction;
}

export type Props = StateProps & DispatchProps;

export const mapState = (state: RootState): StateProps => {
  const { termsOfServices, sort } = state.policy.list;

  return { termsOfServices, sort };
};

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  setParams: (payload: PartialSearchingProps) =>
    dispatch(setTOSListParamsAction(payload))
});

export class TermsOfServiceTable extends React.Component<Props> {
  readonly cols: TableCol<TermsOfService>[];
  readonly deleteModalRef: React.RefObject<DeleteTermsOfServiceModalType>;

  constructor(props: Props) {
    super(props);

    this.deleteModalRef = createRef();

    this.cols = [
      {
        property: 'activation_date',
        label: 'Activation date',
        className: 'col-11',
        sortable: true,
        columnRedirectTo: (row) => getPathUrl(ROUTE_TOS_DETAILS, { id: row.id })
      },
      {
        property: 'published',
        label: 'Published',
        className: 'col-1',
        value: (row) => row.getIsPublished()
      },
      {
        property: null,
        label: 'Action',
        value: (row) => (
          <div className="actions-wrapper">
            <ActionShow
              title="Show terms of service"
              to={getPathUrl(ROUTE_TOS_DETAILS, { id: row.id })}
            />
            <ActionUpdate
              title="Edit terms of service"
              to={getPathUrl(ROUTE_UPDATE_TOS, { id: row.id })}
              disabled={Boolean(row.published)}
            />
            <ActionDelete
              title="Delete terms of service"
              onClick={() => this.deleteModalRef?.current?.open(row)}
              disabled={Boolean(row.published)}
            />
          </div>
        )
      }
    ];
  }

  render(): ReactNode {
    const { termsOfServices, sort, setParams } = this.props;

    return (
      <>
        <DeleteTermsOfServiceModal
          ref={this.deleteModalRef}
          onSuccess={() => setParams({ sort })}
        />
        <Table
          cols={this.cols}
          rows={termsOfServices}
          sort={sort}
          onSort={(params) => setParams({ sort: params })}
        />
      </>
    );
  }
}

export default connect<StateProps, DispatchProps>(
  mapState,
  mapDispatch
)(TermsOfServiceTable);
